import * as React from "react";
import styled from "styled-components";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const SubmitButtonWrapperDefault: React.SFC<IProps> = (props) => {
  const { ...DivProps } = props;

  return <div {...DivProps} />;
};

const SubmitButtonWrapper = styled(SubmitButtonWrapperDefault)`
  margin: 40px auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
`;

export default SubmitButtonWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper.tsx